//import update from 'immutability-helper';

const emptyState = {
  data: {}
}

const AboutReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "ABOUT_INIT": {
      let newData = JSON.parse(JSON.stringify(action.payload));
      return {...state, data: newData};
    }
    default: {
      return state
    }
  }
}

export default AboutReducer